import { render, staticRenderFns } from "./actvity-regist-users.vue?vue&type=template&id=8ee0565e&scoped=true"
import script from "./actvity-regist-users.vue?vue&type=script&lang=js"
export * from "./actvity-regist-users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee0565e",
  null
  
)

export default component.exports